import { ISuperficialPoliceman } from "interfaces/Report";
import * as S from "./styles";

type SuperficialPolicemanModalProps = {
  superficialPoliceman: ISuperficialPoliceman | null;
  modalIsOpen: boolean;
  onCloseButtonClick: () => void;
};

export default function SuperficialPolicemanModal({
  superficialPoliceman,
  modalIsOpen,
  onCloseButtonClick,
}: SuperficialPolicemanModalProps) {
  if (!superficialPoliceman || !modalIsOpen) return null;

  return (
    <S.Overlay>
      <S.Container>
        <S.StyledCloseIcon onClick={onCloseButtonClick} />

        <S.BadgeContainer>
          <span>
            <label>Cadastro efetuado em</label>
            <p>
              {new Date(superficialPoliceman.createdAt).toLocaleDateString(
                "pt-BR",
                {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                }
              )}
            </p>
          </span>
        </S.BadgeContainer>

        <S.DataContainer>
          <h3>Dados do pronta-resposta avulso</h3>
          <S.SuperficialPolicemanContent>
            <span>
              <p>Nome</p>
              <p>{superficialPoliceman?.name}</p>
            </span>
            <span>
              <p>Contato</p>
              <p>{superficialPoliceman?.phoneNumber}</p>
            </span>
          </S.SuperficialPolicemanContent>
        </S.DataContainer>
      </S.Container>
    </S.Overlay>
  );
}
